export const checkPagination = ({ uischema, search }) => {
  let { loadData } = uischema
  let { get, post, method, table, enablePagination } = loadData
  let isLoadGET = method === 'GET'
  let isLoadPOST = method === 'POST'
  let isLoadSEARCH = method === 'SEARCH'
  let isLoadTABLE = method === 'TABLE'
  let isLoadApiGET = method === 'API_CONDITION'

  if (isLoadTABLE) {
    if (enablePagination || table?.enablePagination) {
      return true
    }
  }
  if (
    isLoadGET &&
    (get?.enablePagination ||
      get?.enablePaginationPath ||
      get?.enablePaginationQuery)
  ) {
    return true
  }
  if (isLoadApiGET) {
    return true
  }
  if (
    isLoadPOST &&
    (post?.enablePaginationPath || post?.enablePaginationQuery)
  ) {
    return true
  }
  if (isLoadSEARCH) {
    if (enablePagination) {
      return true
    }
    if (search?.enablePaginationPath || search?.enablePaginationQuery) {
      return true
    }
  }
  return false
}
